import React, { useContext, useState } from 'react'
import SponsoredSignUp from 'components/forms/SponsoredSignUp'
import SignIn from 'components/forms/SignIn'
import { userContext } from 'global/context/sub-contexts/userContext'
import { modalContext } from 'global/context/sub-contexts/modalContext'
import * as yup from 'yup'
import { Formik } from 'formik'
import { login, register } from 'services/auth'
import { getToken } from 'services/user'
import localStorageWrapper from 'util/LocalStorageWrapper'

/* TODO: let's move these to S3. No need to include them in the bundle. */
import formBreak from 'images/signup-thumb-break.jpg'
import formPrizes from 'images/signup-thumb-prizes.jpg'
import formLearnPlay from 'images/signup-thumb-learn-play.jpg'

const validateSignUpForm = yup.object().shape({
  email: yup.string().required(' ').trim(),
  tab: yup.number(),
  password: yup
    .string()
    .min(8, 'Password should be a minimum of 8 characters.')
    .required(' ')
    .trim(),
  birthDate: yup
    .date()
    .required('Birthday cannot be blank')
    .typeError('Birthday must be a date in format dd/mm/yyyy')
    .test({
      name: 'is-at-least-17',
      test: function (value) {
        if (value && Date.parse(value)) {
          let bdate = new Date(value)
          let dateNow = new Date()
          let yearsDiff = dateNow.getFullYear() - bdate.getFullYear()

          if (yearsDiff >= 17) {
            return true
          } else {
            return this.createError({
              message: `You must be 17 years of age or older to sign up.`,
              path: 'birthDatey',
            })
          }
        } else {
          return false
        }
      },
    }),
  captchaResponseToken: yup.string().required('You must complete the captcha'),
})

const SponsoredForm = (onRegistrationSuccess, onLoginSuccess) => {
  const user_context = useContext(userContext)
  const { isLoggedInBoolean } = user_context || {}
  const modal_context = useContext(modalContext)
  const { setSponsoredModal, showModalTemplate } = modal_context || {}

  const [loginError, setLoginError] = useState()
  const [registrationError, setRegistrationError] = useState()

  const onKeyDown = (values, keyEvent) => {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault()
      values.tab === 1 && handleLogin(values.email, values.password)
    }
  }

  const handleLogin = (username, password) => {
    if (isLoggedInBoolean) {
      return
    }
    login(username, password).then(result => {
      if (result.success === true) {
        console.log('logged in')
        user_context.setProfile(result.profile)
        user_context.setPoints(result.profile.points)

        setSponsoredModal(false)

        getToken().then(data => {
          if (data.status === 200) {
            localStorageWrapper.setItem('accessToken', data.detail.accessToken)
          }

          if (onLoginSuccess) {
            onLoginSuccess()
          }
        })
      } else {
        setLoginError('Failed to login to account.')
      }
    })
  }

  const handleRegistration = (email, password) => {
    if (isLoggedInBoolean) {
      return
    }
    register({ email, password }).then(result => {
      if (result.success === true) {
        console.log('registered successfully')
        user_context.setProfile(result.profile)
        setSponsoredModal(false)

        if (onRegistrationSuccess) {
          onRegistrationSuccess().then(function () {
            showModalTemplate('completeprofile')
          })
        } else {
          showModalTemplate('completeprofile')
        }
      } else {
        setRegistrationError('User already exists.')
      }
      // TODO: add result messsage to error when user already exists backend.
    })
  }

  return (
    <Formik
      initialValues={{
        email: '',
        password: '',
        captchaResponseToken: null,
        tab: 0,
      }}
      validateOnBlur={true}
      validateOnChange={true}
      onSubmit={values => {
        values.tab === 0 && handleRegistration(values.email, values.password)
        values.tab === 1 && handleLogin(values.email, values.password)
      }}
      validationSchema={validateSignUpForm}
    >
      {({ values, handleSubmit, setFieldValue, errors, touched }) => {
        return (
          <div className="modal-wrap">
            <form
              onKeyDown={onKeyDown.bind(this, values)}
              onSubmit={handleSubmit}
              id="signinup"
            >
              <div className="modal__tabs">
                <ul className="modal__tabs-list">
                  <li className={`col-6  ${values.tab === 0 ? 'active' : ''}`}>
                    <button
                      type="button"
                      onClick={() => {
                        setFieldValue('tab', 0)
                      }}
                    >
                      Sign Up
                    </button>
                  </li>
                  <li className={`col-6  ${values.tab === 1 ? 'active' : ''}`}>
                    <button
                      type="button"
                      onClick={() => {
                        setFieldValue('tab', 1)
                      }}
                    >
                      Sign In
                    </button>
                  </li>
                </ul>
              </div>
              <div className="modal__tabs-content">
                {values.tab === 1 && (
                  <ul className="signup__perks">
                    <li>
                      <figure>
                        <span>
                          <img src={formBreak} alt="A break in your day" />
                        </span>
                        <figcaption>A break in your day.</figcaption>
                      </figure>
                    </li>
                    <li>
                      <figure>
                        <span>
                          <img
                            src={formPrizes}
                            alt="Win great prizes like HDTVs, $500 Gift Cards"
                          />
                        </span>
                        <figcaption>
                          Win great prizes <small>HDTVs, $500 Gift Cards</small>
                        </figcaption>
                      </figure>
                    </li>
                    <li>
                      <figure>
                        <span>
                          <img
                            src={formLearnPlay}
                            alt="Learn, play, contribute."
                          />
                        </span>
                        <figcaption>Learn, play, contribute.</figcaption>
                      </figure>
                    </li>
                  </ul>
                )}
                <div className="form__wrapper">
                  {values.tab === 0 && (
                    <SponsoredSignUp
                      values={values}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      registrationError={registrationError}
                      onSubmit={handleSubmit}
                    />
                  )}
                  {values.tab === 1 && (
                    <SignIn
                      values={values}
                      setFieldValue={setFieldValue}
                      touched={touched}
                      errors={errors}
                      loginError={loginError}
                    />
                  )}
                </div>
              </div>
            </form>
          </div>
        )
      }}
    </Formik>
  )
}

export default SponsoredForm
